import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]

  connect() {
  }

  toggle(event) {
    event.preventDefault()
    
    const content = event.currentTarget.nextElementSibling
    const icon = event.currentTarget.querySelector('[data-custom-filters-target="icon"]')
    
    content.classList.toggle("hidden")
    content.classList.toggle("opacity-0")
    content.classList.toggle("opacity-100")
    
    icon.classList.toggle("fa-chevron-right")
    icon.classList.toggle("fa-chevron-down")
  }

  submitOnChange(event) {
    const form = event.target.closest('form')
    if (form) form.submit()
  }

  disconnect() {}
}
